import { render } from "./QuotationForCustomer.vue?vue&type=template&id=76398d6b&scoped=true"
import script from "./QuotationForCustomer.vue?vue&type=script&lang=js"
export * from "./QuotationForCustomer.vue?vue&type=script&lang=js"

import "./QuotationForCustomer.vue?vue&type=style&index=0&id=76398d6b&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76398d6b"]])

export default __exports__